
const env = 'prod'
//const env = 'uat'
//const env = 'local'


// default is prod mode
let version = 'version 3.0.3'
let appName = 'contactsync'
let ServerBaseURL = `https://webportal.dsi.gov.mo/${appName}/api`;
let useMockData = false;
let mockMobileIntegration = false;

if ( env == 'local') {
  ServerBaseURL = `http://localhost:29101/${appName}/api`;
  version = '(local) ' + version;
} else if (env == 'uat') {
  ServerBaseURL = `https://app-uat.dsi.gov.mo/uat-${appName}/api`;
  useMockData = true;
  version = '(uat) ' + version;
} else if (env == 'prod') {
  ServerBaseURL = `https://app.dsi.gov.mo/${appName}/api`;

} 

export { version, ServerBaseURL, useMockData, mockMobileIntegration, env}







